import { Injectable } from "@angular/core";
import { appConfig } from "../../constant/app.constant";
import { HttpClient } from "@angular/common/http";
import { EmailNotificationRequest } from "./email-notification-request";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class MessageBusService {    
    private baseUrl = `${appConfig.BASE_URL}ReturnPortalFacade`;

    constructor(private httpClient: HttpClient) { }

    sendEmailNotification(request: EmailNotificationRequest): Observable<void> {
        return this.httpClient.post<void>(`${this.baseUrl}/SendEmailNotification`, request);
    }
}